<template>
    <multiselect v-model="DisplayValue" :options="options" :multiple="false" track-by="name" :clear-on-select="false" :show-labels="false" label="name" placeholder="Select Level" :preselect-first="true">

    </multiselect>

</template>
<script>
    import Multiselect from 'vue-multiselect'
    export default {
        name: 'LevelDropdown',
        props: ["values"],
        components: {
            Multiselect,
        },
        data: function () {
            return {
                options: [],
                value: '',
            }
        },
        methods: {
            getData: function () {
                var root = this;
                if (root.values != undefined && root.values != null && root.values != '') {
                    root.value = root.options.find(function (x) {
                        return x.name == root.values;
                    });
                }
            },
        },
        computed: {
            DisplayValue: {
                get: function () {
                    if (this.value != "" || this.value != undefined) {

                        return this.value;
                    }
                    return this.value;
                },
                set: function (value) {

                    this.value = value;
                    this.$emit('input', value == null ? null : value.name);
                }
            }
        },
        mounted: function () {
            var root = this;
            root.options.push({ name: 'Level One' });
            root.options.push({ name: 'Level Two' });
            root.options.push({ name: 'Level Three' });
            root.options.push({ name: 'Level Four' });
            root.options.push({ name: 'Level Five' });
            root.options.push({ name: 'Level Six' });
            root.options.push({ name: 'Level Seven' });
            root.options.push({ name: 'Level Eight' });



            this.getData();
        },
    }
</script>